export default __webpack_public_path__ + "static/media/8.745441c4.jpeg";